namespace TabAurous.Inventory {
    export namespace CertificationReturnLaborService {
        export const baseUrl = 'CertificationReturn/CertificationReturnLabor';

        export declare function Create(request: Serenity.SaveRequest<CertificationReturnLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CertificationReturnLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CertificationReturnLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CertificationReturnLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CertificationReturn/CertificationReturnLabor/Create",
            Update = "CertificationReturn/CertificationReturnLabor/Update",
            Delete = "CertificationReturn/CertificationReturnLabor/Delete",
            Retrieve = "CertificationReturn/CertificationReturnLabor/Retrieve",
            List = "CertificationReturn/CertificationReturnLabor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CertificationReturnLaborService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
